import { NavArrowDown } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from '../Icon.types';

const ArrowDownIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <NavArrowDown width={size} height={size} color={color} {...rest} />;

ArrowDownIcon.displayName = 'ArrowDownIcon';

export default ArrowDownIcon;
